import { render, staticRenderFns } from "./rent.vue?vue&type=template&id=ae8a97fc&lang=html&"
import script from "./rent.vue?vue&type=script&lang=js&"
export * from "./rent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports